import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthorizationsService } from '../../common/services/data-model/app/authorizations/authorizations.service';
import { ClaimFormNavigationService } from '../../common/services/support/claim-form-navigation/claim-form-navigation.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApplicationConstants } from '../../common/constants/application.constants';
import { DrReportsNavigationService } from '../../common/services/support/dr-reports-navigation/dr-reports-navigation.service';
import { openDialog } from '../../common/utility';
import { CommercialGapProviderService } from '../../common/services/data-model/app/commercial-gap-provider/commercial-gap-provider.service';

@Component({
  selector: 'app-authorization-confirmation',
  templateUrl: './authorization-confirmation.component.html',
  styleUrls: ['./authorization-confirmation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthorizationConfirmationComponent implements OnInit {

  private _authorizationNumber: string;
  public showAuthorizationDetailsReport = false;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private authorizationService: AuthorizationsService,
    private claimFormNavigationService: ClaimFormNavigationService,
    private drReportsNavigationService: DrReportsNavigationService,
    private commercialGapProviderService: CommercialGapProviderService,
  ) { }

  get authorizationNumber(): string {
    return this._authorizationNumber;
  }

  set authorizationNumber(number: string) {
    this._authorizationNumber = number;
  }

  ngOnInit() {
    if (this.authorizationService.vsrNumber) {
      this.authorizationNumber = this.authorizationService.vsrNumber;
      const networkId = this.authorizationService.getNetworkIdFromVsr(this.authorizationNumber);

      this.commercialGapProviderService.shouldShowCommercialGapReport(networkId).subscribe((showReport) => {
        this.showAuthorizationDetailsReport = showReport;
      });
    } else {
      this.router.navigate([ApplicationConstants.routing.secure.memberSearchPageUrl]);
    }
  }

  // TODO: This is temporary to go to legacy CMS1500 page; Auth Number is hardcoded currently, when plugged with APIs, get the real one.
  goToClaimForm() {
    // Calling LoadingModalComponent for Spinner (Preload Icon)
    openDialog('', this.dialog);
    this.claimFormNavigationService.searchAndRetrieveOrCreatePatientEncounterThenLoadDoctorsThenNavigateToClaimForm(this.authorizationNumber, undefined, this.authorizationService.getEffectiveDateFromVsr(this.authorizationNumber)).subscribe(() => {
      // Broadcast value is null, no need for closure
    }, () => {
      // Errors are handled in the HTTP layer for PE, no need for error closure
    }, () => {
      // Close the dialog when the observer completes
      this.dialog.closeAll();
    });
  }

  showPatientRecordReport() {
    this.drReportsNavigationService.navigateToPatientRecordReport(this._authorizationNumber);
  }

  showAuthDetailsReport() {
    this.drReportsNavigationService.showAuthDetailsReport(this._authorizationNumber);
  }

}
